import React, { useState } from 'react'

import useText from '../../../common/hooks/useText'
import { LogsTable, LOGS_NO_OF_ITEMS } from '../../../lib/logs-table'
import { IFilters } from '../charge-point-logs-widget'
import { CHARGE_POINT_REFRESH_TIMEOUT } from '../../../common/constants/ChargePointConstants'
import { FilterButton } from '../../../lib/filter-button'
import { FilterModal } from '../../../lib/filter-modal'
import { WidgetLayout } from '../../../lib/widget-layout'
import { isMoreItemsToLoad } from '../../../lib/is-more-items-to-load'
import { useChargePointDataGetChargePointDataWithFilterQuery } from '../../../common/redux/api/web-api'

export type ChargepointChargerDataWidgetProps = {
    chargePointId: string
}

export interface IChargerDataLog {
    connectorId: string
    dataTypeDescription: string
    timestamp: string
    showData: boolean
    formattedData: string
}

export function ChargepointChargerDataWidget({ chargePointId }: ChargepointChargerDataWidgetProps): React.ReactElement {
    const text = useText()
    const [filters, setFilters] = useState<IFilters>({
        dataType: {
            WifiInfo: false,
            Temperature: false,
            ProcessorVoltage: false,
            PwmStateShifts: false,
            Pwm: false,
            GfcidcWaveform: false,
            ClientInfo: false,
        },
    })
    const [noOfItems, setNoOfItems] = useState(LOGS_NO_OF_ITEMS)

    const {
        data: logs = [],
        isLoading,
        isFetching,
    } = useChargePointDataGetChargePointDataWithFilterQuery(
        { chargePointId, noOfItems, dataLogFilter: filters },
        {
            pollingInterval: CHARGE_POINT_REFRESH_TIMEOUT,
        }
    )

    const [isFilterModalVisible, setIsFilterModalVisible] = useState(false)

    return (
        <WidgetLayout
            loadingStatus={isLoading}
            headerButtons={<FilterButton action={() => setIsFilterModalVisible(!isFilterModalVisible)} />}
            data-testid="chargerData"
        >
            {isFilterModalVisible && (
                <FilterModal
                    onClose={(newFilters) => {
                        setIsFilterModalVisible(false)
                        setFilters(newFilters)
                    }}
                    filters={filters}
                />
            )}
            <LogsTable
                columns={[
                    {
                        label: text('lblConnectorShort'),
                        accessor: 'connectorId',
                        width: 50,
                    },
                    {
                        label: text('lblDataType'),
                        accessor: 'dataTypeDescription',
                        width: 150,
                    },
                    {
                        label: text('lblTimestamp'),
                        accessor: 'timestamp',
                        width: 100,
                    },
                    {
                        label: text('lblValue'),
                        accessor: 'formattedData',
                    },
                ]}
                logs={logs}
                actions={
                    isMoreItemsToLoad(noOfItems, logs.length)
                        ? [
                              {
                                  title: text('btnLoadMore'),
                                  onClick: () => {
                                      setNoOfItems((current) => current + logs.length)
                                  },
                              },
                          ]
                        : []
                }
                loading={isLoading || isFetching}
            />
        </WidgetLayout>
    )
}
